import PropTypes from "prop-types";
import { connect } from "react-redux";
import { changeNavigation } from "../../../store/slices/navigationSlice";
import { Outlet } from "react-router-dom";
import { useMountEffect } from "primereact/hooks";

const NavigationUpdater = ({
  menu,
  changeNavigation,
  parent,
  shouldUpdate = true,
  action = "",
  children = null,
}) => {
  useMountEffect(() => {
    if ((menu || parent) && shouldUpdate) {
      changeNavigation({
        parent: parent.id,
        child: menu?.id || parent.id,
        action,
      });
    }
  });
  return children || <Outlet />;
};

NavigationUpdater.propTypes = {
  menu: PropTypes.object,
  parent: PropTypes.object,
  shouldUpdate: PropTypes.bool,
  action: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  changeNavigation: (menu) => dispatch(changeNavigation(menu)),
});

export default connect(null, mapDispatchToProps)(NavigationUpdater);
